
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-31a6dc04\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../node_modules/string-replace-loader/index.js??ref--9!../../node_modules/string-replace-loader/index.js??ref--10!../../node_modules/string-replace-loader/index.js??ref--11!../../node_modules/string-replace-loader/index.js??ref--12!./GiftRedirect.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/string-replace-loader/index.js??ref--9!../../node_modules/string-replace-loader/index.js??ref--10!../../node_modules/string-replace-loader/index.js??ref--11!../../node_modules/string-replace-loader/index.js??ref--12!./GiftRedirect.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-31a6dc04\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/string-replace-loader/index.js??ref--9!../../node_modules/string-replace-loader/index.js??ref--10!../../node_modules/string-replace-loader/index.js??ref--11!../../node_modules/string-replace-loader/index.js??ref--12!./GiftRedirect.vue"),
  /* scopeId */
  "data-v-31a6dc04",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/GiftRedirect.vue
// module id = 854
// module chunks = 0